const ACCESS_TOKEN_KEY = 'access_token';
const getCurrentAccessToken = () =>
	window.sessionStorage.getItem(ACCESS_TOKEN_KEY) || window.localStorage.getItem(ACCESS_TOKEN_KEY);
let hasLoadedReactConfigs = false;

async function loadConfig() {
	const token = getCurrentAccessToken();
	if (hasLoadedReactConfigs) {
		return;
	}

	const fetchOptions = {
		headers: token ? { Authorization: `Bearer ${token}` } : {},
	};
	const res = await fetch('/env/react-config.js', fetchOptions);
	const text = await res.text();

	const inlineScript = document.createElement('script');
	inlineScript.type = 'text/javascript';
	inlineScript.text = text;
	document.head.appendChild(inlineScript);
	hasLoadedReactConfigs = !!token;
}

function addAccessTokenListener() {
	['localStorage', 'sessionStorage'].forEach(storageType => {
		const storage = window[storageType];
		const originalSetItem = storage.setItem;

		storage.setItem = function (key, value) {
			originalSetItem.apply(this, arguments);
			if (key === ACCESS_TOKEN_KEY && value) {
				loadConfig();
			}
		};
	});
}

async function initializeApp() {
	await loadConfig();
	await import('./index.jsx');
	addAccessTokenListener();
}

initializeApp();
